import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Shared patient banner: photo | demographics + PMR | chart metrics | diet | allergies.
 * Parents supply formatted strings and handle copy / image error.
 */
@Component({
  selector: 'app-patient-clinical-banner',
  templateUrl: './patient-clinical-banner.component.html',
  styleUrls: ['./patient-clinical-banner.component.css']
})
export class PatientClinicalBannerComponent {

  @Input() profileImageUrl: string;
  @Input() patientIdDisplay: string | number;
  @Input() genderText: string;
  @Input() birthdateText: string;
  /** When empty, age value is hidden (label still shown). */
  @Input() ageText: string = '';
  /** PMR / PatGrpMast label text (may be empty). */
  @Input() pmrText: string = '';
  @Input() creatinineDateLine: string = '';
  @Input() weightDisplay: string = '';
  @Input() heightDisplay: string = '';
  @Input() creatinineCrDisplay: string = '';
  @Input() creatinineCrClDisplay: string = '';
  @Input() dietText: string = '';
  @Input() allergiesText: string = '';

  @Output() profileImageError = new EventEmitter<void>();
  @Output() copyPatientId = new EventEmitter<void>();

  get hasAge(): boolean {
    return this.ageText != null && String(this.ageText).trim() !== '';
  }

  get hasCreatinineDateLine(): boolean {
    return this.creatinineDateLine != null && String(this.creatinineDateLine).trim() !== '';
  }

  onImageError(): void {
    this.profileImageError.emit();
  }

  onCopyPatientId(): void {
    this.copyPatientId.emit();
  }

  cellValue(v: string): string {
    if (v == null || String(v).trim() === '') {
      return '\u2014';
    }
    return String(v);
  }
}
